(function () {
	const initProductAccordion = () => {
		document.querySelectorAll('.about__accordion-toggle').forEach(toggle => {
			if (toggle.dataset.aboutAccordionBound === 'true') {
				return;
			}

			toggle.dataset.aboutAccordionBound = 'true';
			toggle.addEventListener('click', function () {
				const isActive = this.classList.contains('active');
				const description = this.parentElement.querySelector('.about__accordion-description');
				if (!isActive) {
					this.classList.add('active');
					if (description) {
						description.style.display = 'block';
					}
				} else {
					this.classList.remove('active');
					if (description) {
						description.style.display = 'none';
					}
				}
			});
		});
	};

	if (document.documentElement.dataset.aboutAccordionScriptBound === 'true') {
		return;
	}

	document.documentElement.dataset.aboutAccordionScriptBound = 'true';

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
